module.exports = __webpack_public_path__ + "media/cz.052ec527.svg";